<template>
	<div class="md-layout text-center">
		<div class="md-layout-item md-size-100">
			<!-- <img id="login-logo" src="/img/logo-name.png"> -->
		</div>
		<div class="md-layout-item md-size-33 md-medium-size-50 md-small-size-70 md-xsmall-size-100">
			<login-card header-color="">
				<p slot="description" class="description" id="loginTitle">Login</p>
					<md-field class="md-form-group" slot="inputs">
						<md-icon>email</md-icon>
						<label>Email</label>
						<md-input @keydown.enter="executeLogin" @keydown="tooltipActive = false" v-model="email" type="email" v-validate="'required|email'"></md-input>
					</md-field>
					<md-field class="md-form-group" slot="inputs">
						<md-icon>lock_outline</md-icon>
						<label>Senha</label>
						<md-input @keydown.enter="executeLogin" @keydown="tooltipActive = false" type="password" v-model="password"></md-input>
					</md-field>

					<md-button @click="executeLogin" slot="footer" class="md-accent md-lg" type='submit'>
						Entrar
					</md-button>
			</login-card>
		</div>
	</div>
</template>
<script>
import userModel from "@/models/user.model";
import permissionModel from "@/models/permission.model";
import { isActive } from "@/models/session";

import { LoginCard } from "@/components";

import EspressoAux from "@/components/Espresso/EspressoAux.vue";

export default {
  components: {
    LoginCard
  },
  methods: {
    executeLogin: function() {
			permissionModel.resetMyPermissions();
      if (
        !this.email ||
        !this.password ||
        this.password.length < 2 ||
        this.email.length < 2
      ) {
        EspressoAux.showFailModal("Preencha os campos de login.");
      } else {
        this.$validator.validateAll().then(res => {
          if (res) {
            return userModel.login(this.email, this.password)
              .then(success => {
                if (success) {
                  document.location.href = "/escalas";
                } else {
                  throw Error("ERR_LOGIN");
                }
              })
              .catch(error => {
				if (error.message === "API_NOT_FOUND" || error.message === "Validation error") {
                  EspressoAux.showFailModal("Email ou senha incorretos.");
                } else {
                  EspressoAux.showFailModal();
                  console.error(error);
                }
              });
          } else {
            EspressoAux.showFailModal("Email inválido.");
          }
        });
      }
    }
  },
  data() {
    return {
      email: null,
      password: null
    };
  },
  created() {
    if (isActive()) {
      document.location.href = "/escalas";
    }
  }
};
</script>

<style>
#loginTitle {
  font-size: 24px;
  color: black;
  margin-bottom: 40px;
  margin-top: -15px;
}

#login-logo {
  height: auto;
  margin: 25px auto;
  width: 100px;
  display: block;
}

@media (max-width: 768px) {
  .login-page.page-header > .container {
    padding-top: 0;
  }
}
</style>

